import * as React from 'react';
import type { SVGProps } from 'react';
const SvgResend = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#A5A5AA"
      fillRule="evenodd"
      d="M7.53 17.69a.602.602 0 0 1 .722.454l.56 2.455a.603.603 0 0 1-.453.722l-2.455.56a.605.605 0 0 1-.721-.452.602.602 0 0 1 .453-.722l.965-.22a9.982 9.982 0 0 1-4.172-9.28 9.933 9.933 0 0 1 3.694-6.702 9.933 9.933 0 0 1 7.351-2.127.602.602 0 0 1-.133 1.197 8.738 8.738 0 0 0-6.466 1.871 8.735 8.735 0 0 0-3.248 5.895 8.78 8.78 0 0 0 3.705 8.187l-.255-1.116a.603.603 0 0 1 .453-.721ZM18.993 3.805l-1.016.232a9.982 9.982 0 0 1 4.326 9.387 9.934 9.934 0 0 1-3.693 6.702 9.924 9.924 0 0 1-7.351 2.127.602.602 0 0 1 .133-1.197 8.726 8.726 0 0 0 6.465-1.87 8.735 8.735 0 0 0 3.25-5.896 8.78 8.78 0 0 0-3.797-8.25l.242 1.06a.602.602 0 1 1-1.174.268l-.561-2.455a.603.603 0 0 1 .453-.722l2.455-.56a.602.602 0 1 1 .268 1.174ZM7.18 16.392h10.445c.332 0 .602-.27.602-.602V9.107l-5.42 4.933a.601.601 0 0 1-.81 0l-5.42-4.933v6.683c0 .332.27.602.603.602Zm.233-8.153h9.979l-4.99 4.541-4.989-4.54Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgResend;
